<div
  mdbModal
  #consultaRecorridoDetalle="mdb-modal"
  class="modal fade"
  style="overflow-y: auto"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-fluid" style="width: 90%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Detalle recorrido</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="consultaRecorridoDetalle.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="row" >
          <div class="col">
            <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
              No existen registros para el filtro seleccionado</a>
          </div>
        </div> -->
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Rec.</th>
                <th scope="col">Fecha Rec.</th>
                <th scope="col">Patente</th>
                <th scope="col">Chofer</th>
                <th scope="col" class="text-right">Total</th>
                <th scope="col" class="text-center">Estado</th>
                <th scope="col" class="text-right">Total Liq.</th>
                <th scope="col">Fec. Liq.</th>
                <th scope="col" class="text-right">Efectivo</th>
                <th scope="col" class="text-right">Transferencia</th>
                <!-- <th scope="col" class="text-right">Depositos</th> -->
                <th scope="col" class="text-right">Cheque</th>
                <th scope="col" class="text-right">Nota Cred.</th>
                <th scope="col" class="text-right">Nota Deb.</th>
                <th scope="col" class="text-right">Cobro Vend.</th>
                <th scope="col" class="text-right">Anticipo</th>
                <th scope="col" class="text-right">Reverso</th>
                <th scope="col" class="text-right">Cargo Tran.</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">No se encontró información</td>
              </tr>
              <tr *ngFor="let mov of listaMovimientos">
                <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.codigo | numerico }}</td>
                <td *ngIf="mov.codigo === 0"></td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.fecha | fecha }}</td>
                <td *ngIf="mov.codigo === 0"></td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.camion_patente }}</td>
                <td *ngIf="mov.codigo === 0">FE-{{ mov.folio | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.nombreChofer }}</td>
                <td *ngIf="mov.codigo === 0">[{{ mov.rutFormato | rut }}] {{ mov.razon_social }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.total_documentos | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.total_documentos | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="text-center">
                  <mdb-badge *ngIf="mov.codigo_estado === 1" pill="true" info="true">{{ mov.nombre_estado }}</mdb-badge>
                  <mdb-badge *ngIf="mov.codigo_estado === 2" pill="true" warning="true">{{ mov.nombre_estado }}</mdb-badge>
                  <mdb-badge *ngIf="mov.codigo_estado === 3" pill="true" success="true">{{ mov.nombre_estado }}</mdb-badge>
                </td>
                <td *ngIf="mov.codigo === 0"></td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.total_liq | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right"></td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.fecha_liq | fecha }}</td>
                <td *ngIf="mov.codigo === 0"></td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.efectivo | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.efectivo | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.transferencia | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.transferencia | numerico }}</td>
                <!-- <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.deposito | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.deposito | numerico }}</td> -->
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cheque | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cheque | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.nota_credito | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.nota_credito | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.nota_debito | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.nota_debito | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cobro_vendedor | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cobro_vendedor | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.anticipo | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.anticipo | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.reverso | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.reverso | numerico }}</td>
                <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cargo_transp | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cargo_transp | numerico }}</td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMovimientos?.length > 0"></app-pagination>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal" (click)="consultaRecorridoDetalle.hide()" mdbWavesEffect>Cerrar</button>

        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')">
          Excel
        </button>
      </div>
    </div>
  </div>
</div>
